/*TODO: work on deprecating this in favor of simpler ButterBar component,
pulled in from appCatalog.*/
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from '../../core/withRouter'

@inject('store')
@observer
class AlertMessage extends React.Component {

	static propTypes = {
    className: PropTypes.string,
    handleCloseClick: PropTypes.func,
    title: PropTypes.string,
    message: PropTypes.string,
    inline: PropTypes.bool,
    formColClass: PropTypes.string,
		type: PropTypes.string,
		store: PropTypes.object, //Prop for AppControl Only
		location: PropTypes.object //Prop for AppControl Only
  };

  static defaultProps = {
    type: 'error',
    title: '',
    message: '',
    formColClass: ''
  }

  renderAlert = () => {
    if (!this.message) {
      return '';
    }
    const messageIsTwoParts = this.title && this.message;
    const mainMessage = messageIsTwoParts ? this.title : this.message;
    const details = messageIsTwoParts ? this.message : '';
    return (<div className={`alert alert-${this.type}`}>
      <button type="button" className="close_btn icon-close" onClick={this.clearAlerts.bind(this)}>
        <span className="sr-only">Close alert</span>
      </button>
      <p><strong dangerouslySetInnerHTML={{
          __html: mainMessage
        }}></strong></p>
      {details
        ? <p className="alert-details" dangerouslySetInnerHTML={{
            __html: details
          }}></p>
        : ''}
    </div>)
  }

  render() {
		/*-----begin special App-Control-only alert handling------*/
		let pendingAlert = this.props.store.alerts.get(this.props.location.pathname);
		if(!pendingAlert){return(null)}
		this.title = pendingAlert.title;
		this.message = pendingAlert.message;
		this.type = pendingAlert.type;
		/*-----resume standard handling------*/

    return (<div className={`alert-bars ${this.props.formColClass}`}>
      {/* Screen reader section should always be present, not conditionally
        rendered, to allow aria to manage changes appropriately. */
      }
      <p className="sr-only" role="alert" aria-live="assertive" aria-atomic="true">
        {this.title ? this.title + '. ' : ''}&nbsp;{this.message}
      </p>
      {this.renderAlert()}
    </div>)
  }

	/*-----begin special App-Control-only alert handling------*/
	clearAlerts(){
		this.props.store.clearAlerts(this.props.location.pathname);
	}

	componentWillUnmount(){
		this.clearAlerts();
	}
	/*-----resume standard handling------*/
}

export default withRouter(AlertMessage);
